import {Vue} from 'ui.vue';
import {Vuex} from 'ui.vue.vuex';


import './BXmakerAuthuseremailLogin.css';

import './BXmakerAuthuseremailLoginEmail';
import './BXmakerAuthuseremailLoginCode';
import './BXmakerAuthuseremailLoginRegistration';


import '../BXmakerAuthuseremailInput';
import '../BXmakerAuthuseremailButton';
import '../BXmakerAuthuseremailHeader';
import '../BXmakerAuthuseremailAuthorized';


Vue.component('BXmakerAuthuseremailLogin',
    {
        props: [
            'data',
        ],
        data: function () {
            return {
                isCheckCode: true,
            };
        },
        computed: {
            ...Vuex.mapState('bxmaker/authuseremail/login', [
                'rand', 'isAuthorized', 'authReloadAfter', 'isShowCodeBlock', 'isShowLoginBlock',
            ]),
        },
        methods: {
            onClickChangeEmail() {
                this.$store.commit('bxmaker/authuseremail/login/showEmailBlock');
                this.$store.commit('bxmaker/authuseremail/login/resetMessage');
            },
            onClickRegister() {
                this.$store.commit('bxmaker/authuseremail/login/showRegistrationBlock');
                this.$store.commit('bxmaker/authuseremail/login/resetMessage');
            },
            onClickAuth() {
                this.$store.commit('bxmaker/authuseremail/login/showLoginBlock');
                this.$store.commit('bxmaker/authuseremail/login/resetMessage');
            },
        },
        template: `
            <div class="bxmaker-authuseremail-login" :class="'bxmaker-authuseremail-login--' + this.rand" :id="'bxmaker-authuseremail-login' + this.rand" >
                
                <BXmakerAuthuseremailAuthorized v-if="isAuthorized" />
                                                   
                <template v-else-if="isShowLoginBlock">
                    <BXmakerAuthuseremailLoginEmail v-if="!isShowCodeBlock" />   
                    
                    <BXmakerAuthuseremailLoginCode  v-else /> 
                    
                    <div class="bxmaker-authuseremail-login__nav">
                        <BXmakerAuthuseremailLink @onClick="onClickRegister" >
                            {{$root.localize.BXMAKER_AUTHUSEREMAIL_REGISTRATION_BUTTON}} 
                        </BXmakerAuthuseremailLink>
                    </div>
                </template>     
                
                <template v-else>
                    <BXmakerAuthuseremailLoginRegistration v-if="!isShowCodeBlock" />   
                    
                    <BXmakerAuthuseremailLoginCode   v-else /> 
                    
                    <div class="bxmaker-authuseremail-login__nav">
                        <BXmakerAuthuseremailLink @onClick="onClickAuth" >
                        {{$root.localize.BXMAKER_AUTHUSEREMAIL_AUTH_BUTTON}} 
                        </BXmakerAuthuseremailLink>
                    </div>
                </template>                         
                
            </div>
        `,
    });